import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { getHistoricalStocks, getMostActiveStocks, getTopGainers, getTopLosers , gethomenewsVideos, getCompanyVideos, getStockAnalysis } from './client/home-client';
import { mapPaginatorData } from '../utils/data-mappers';

export const useHistoricalStocksQuery = ({ period, ...params }) => {
  return useQuery({
    queryKey: ["historical-stocks", period,{ ...params }],
    queryFn: () =>
      getHistoricalStocks.get({
        period,
        ...params,
      }),
    enabled: !!period, // safety
    staleTime: 5 * 60 * 1000, // cache 5 min
  });
};

export const useMostActiveQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ['most-active-stocks', params],
    queryFn: () => getMostActiveStocks.all( params ),
    keepPreviousData: true,
  });
  //console.log("most active list data:", data);
  return {
    data: data?.data,
    sectors:data?.sectors,
    metaData: data?.metadata,    
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useTopGainersQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ['top-gainers', params],
    queryFn: () => getTopGainers.all( params ),
    keepPreviousData: true,
  });
  //console.log("most active list data:", data);
  return {
    data: data?.data,
    sectors:data?.sectors,
    metaData: data?.metadata,
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useTopLosersQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ['top-losers', params],
    queryFn: () => getTopLosers.all( params ),
    keepPreviousData: true,
  });
  //console.log("most active list data:", data);
  return {
    data: data?.data,
    sectors:data?.sectors,
    metaData: data?.metadata,   
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};


export const useHoneNewsVideosQuery = ( params ) => {
  //console.log("params====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ['home-news-videos', params],
    queryFn: () => gethomenewsVideos.all( params ),
    keepPreviousData: true,
  });
  //console.log("most active list data:", data);
  return {
    data: data?.data,
    sectors:data?.sectors,
    metaData: data?.metadata,   
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useCompanyVideosQuery = ( params ) => {
  //console.log("params::>====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ['company-news-videos', params],
    queryFn: () => getCompanyVideos.all( params ),
    keepPreviousData: true,
  });
  //console.log("company youtube data=======:", data);
  return {
    data: data?.data,
    sectors:data?.sectors,
    metaData: data?.metadata,   
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useStockAnalysisQuery = ( params ) => {
  //console.log("params::>====", params);
  const { data, error, isLoading } = useQuery({
    queryKey: ['company-news-videos', params],
    queryFn: () => getStockAnalysis.all( params ),
    keepPreviousData: true,
  });
  //console.log("company youtube data=======:", data);
  return {
    data: data?.data,
    sectors:data?.sectors,
    metaData: data?.metadata,   
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};
